export const baseURL = "https://admin.egchat.live/";
export const key = "8{vWkyP/zyJne9s";

